<div container>
  <div class="stages__text text-lg-center mb-4">
    <h2 class="mb-3">Type 1 diabetes progresses in stages</h2>
    <p class="mb-0">
      Each stage is defined by how many beta cells remain. As more beta cells
      are lost your body becomes less able to produce insulin and in turn
      regulate blood sugar levels.
    </p>
  </div>
  <div class="stages__cards d-flex flex-wrap justify-content-center">
    @for (card of cards; track $index) {
    <div class="card overflow-hidden card--{{ card.color }}">
      <div
        class="card__top-title fw-bold text-center position-absolute top-0 start-0 w-100 bg-{{
          card.color
        }}"
        [innerHTML]="card.topTitle"
      ></div>
      <div class="card__stage text-center">
        <h3>
          Stage <br />
          <span [innerHTML]="card.number"></span>
          <!-- @if (card.footnote) {
          <sup>*</sup>
          } -->
        </h3>
      </div>
      <hr class="card__divider" />
      <div class="card__text">
        <!-- <h4 class="h3 mb-3" [innerHTML]="card.title"></h4> -->
        <ul class="mb-0">
          @for (bullet of card.list; track bullet) {
          <li [innerHTML]="bullet"></li>
          }
        </ul>
      </div>
      @if (card.footnote) {
      <p
        class="card__footnote mt-2 mt-lg-5 mb-0"
        [innerHTML]="card.footnote"
      ></p>
      }
    </div>
    }
  </div>
</div>
